export const checkSpecialCharacters = (charString: string) => {
    let inValidCharacter = /[<>()&#]/;
    return inValidCharacter.test(charString);
}